<template>
    <v-dialog ref="dialog" v-model="modal" persistent width="390px">
        <template v-if="!readonly" v-slot:activator="{ on }">
            <v-text-field ref="text" class="date-picker" v-model="selectedDates" :label="label" readonly v-on="on" :rules="rules.datepicker"
                append-icon="mdi-calendar"></v-text-field>
        </template>
        <template v-else v-slot:activator="{  }">
            <v-text-field v-model="selectedDates" :label="label" readonly :rules="rules.datepicker"></v-text-field>
        </template> 

        <v-date-picker class="range-date-picker" v-model="dates" scrollable :locale="locale" range 
            :selected-items-text="selectedDates">
            <v-spacer></v-spacer>
            <v-btn class="danger" @click="modal = false">{{cancel}}</v-btn>
            <v-btn @click="reset">{{clear}}</v-btn>
            <v-btn class="success" @click="save">{{confirm}}</v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
export default {
    name: "range-date-picker", 
    props:{
        label:{
            required: true, 
            type: String
        },
        value:{
            required: false,
            type: Array
        },
        required:{
            required: false,
            type: Boolean
        },
        requiredText:{
            required: true, 
            type: String            
        },
        readonly:{
            required: false,
            default: false,
            type: Boolean
        }
    },
    watch:{
        value(newValue){
            if(newValue != null && newValue.length == 2){
                this.dates = [
                    this.$moment(newValue[0]).format("YYYY-MM-DD"),
                    this.$moment(newValue[1]).format("YYYY-MM-DD")
                ];
            } 
            else
                this.dates = [];            
        }
    },
    data(){
        return {
            dates: [],
            modal: false,
            locale: null,
            rules:{
                datepicker: [
                    val => {
                        if(!this.required) return true;

                        if((val || null) == null)
                            return this.requiredText;

                        if(this.dates.length == 1)
                            return this.$t("Common.enddate-mandatory");
                        
                        if(this.dates[0] > this.dates[1])
                            return this.$t("Common.startdate-greater-than-enddate");                        

                        return true;
                    }
                ]                          
            },             
        }
    },
    computed: {  
        cancel () {
            return this.$t("Common.cancel");
        },
        clear () {
            return this.$t("Common.clear");
        },        
        confirm () {
            return this.$t("Common.confirm");
        },   
        selectedDates: {
            get () {
                if(this.dates == null || this.dates.length == 0) return null;
                let dates = this.$moment(this.dates[0]).format('L');

                if(this.dates.length <= 1) return dates;
                return `${dates} ~ ${this.$moment(this.dates[1]).format('L')}`; 
            },
            set (val) {
                this.dates = [];
            }
        }     
    },  
    async created(){
        this.$events.$on("locale-has-changed", this.setLocale);
        this.setLocale(this.$locale);
    },    
    beforeDestroy(){
        this.$events.$off("locale-has-changed", this.setLocale);
    },
    methods:{
        setLocale(locale){
            switch(locale){
                case process.env.VUE_APP_DB_LOCALE_ES:
                    this.$moment.locale("es");   
                    this.locale = "es";

                    break;

                case process.env.VUE_APP_DB_LOCALE_EN:
                    this.$moment.locale("us");   
                    this.locale = "us";

                    break;

                default:
                    this.$moment.locale("pt-br"); 
                    this.locale = "pt-br";

                    break;                        
            }         
        },        
        reset(){
            this.modal = false;
            this.dates = [];
            this.$emit("input", []);
        },
        save(){
            this.modal = false;

            if(this.dates.length == 2){
                this.$emit("input", [
                    this.$moment(this.dates[0]).toDate(),
                    this.$moment(this.dates[1]).toDate()
                ]);
            }
        }       
    }
}
</script>

<style lang="scss">
@import "../../styles/material-dashboard/variables";

.range-date-picker{
    .v-date-picker-title{
        .v-date-picker-title__year{
            font-size: 30px;
        }
        .v-date-picker-title__date{
            font-size: 22px;
        }
    }
}
</style>
